<template>

<!-- :class="classObject" 下滚会出现学习到这里的提示 --现在去掉了  -->
  <div class="appBody bg-grey-light"  v-if="currentCourse">
<!--    <div class="shareImg position-fixed cursor-pointer">-->
<!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
<!--    </div>-->

    <div>
      <course-top type="chome" :currentItem=currentCourse :alreadyLearn=alreadyLearned
                  :lastLearnedSession=lastLearnSession :projectId="proId"
                  class="course-main-top"></course-top>
      <course-mulu-component type="chome" :curCourse="currentCourse">
        <div class="b-title mb-0 bg-white d-flex align-items-center">
          课程目录
        </div>
      </course-mulu-component>
      <!--<teacher-course class="c_zj" :teacherList="expertList">-->
      <!--<p class="text-center text-white mb-0 font-18 line-18">项目引领</p>-->
      <!--</teacher-course>-->
      <little-footer></little-footer>
      <!-- 下滚会出现上次学习到这里的提示 --现在去掉了  -->
<!--      <div class="tip-course w-100 p-3"-->
<!--           v-if="isShow && currentCourse.userCourse && currentCourse.userCourse.lastLearnSessionTitle">-->
<!--        <div class="w-100  d-flex justify-content-between align-items-center">-->
<!--          <div class="w-75">-->
<!--            <h6 class="van-ellipsis">{{lastLearnSession.title?lastLearnSession.title:''}}</h6>-->
<!--            <p class="mb-0 font-10 line-10 color-3e d-flex justify-content-between align-items-center">-->
<!--              {{alreadyLearned?'上次学习到这里':'开始学习'}}-->
<!--            </p>-->
<!--          </div>-->
<!--          <router-link class="bg-base font-11 line-11 xi-btn d-inline-block"-->
<!--                       :to="{path: '/course/'+lastLearnSession.sessionType+'/'+lastLearnSession.id}">-->
<!--            {{alreadyLearned?'继续学习':'开始学习'}}-->
<!--          </router-link>-->
<!--        </div>-->
<!--      </div>-->

    </div>

  </div>
</template>

<script>
  import CourseTop from '@/components/courseTop'
  import CourseMuluComponent from '@/components/courseMuluComponent'
  import TeacherCourse from '@/components/teacherCourse'
  import littleFooter from '@/page/lecturer/components/littleFooter';

  export default {
    name: "courseHome",
    data() {
      return {
        isShow: false,
        expertList: [],
        courseMuluObj: {},
        showShare: false,
        alreadyLearned: false,
        shareObj: {},
        currentCourse: {},
        lastLearnSession: {},
        proId: '',
      }
    },

    computed: {
      classObject: function () {
        return {
          'mb-4r': this.isShow === true && this.currentCourse && this.currentCourse.userCourse && this.currentCourse.userCourse.lastLearnSessionTitle
        }
      }
    },
    created() {

    },
    components: {
      CourseTop,
      CourseMuluComponent,
      TeacherCourse,
      littleFooter,
    },

    mounted() {
      this.courseId = this.$route.params['id'];
      this.proId = this.$route.query['proId'];
      if (this.proId) {
        this.getProjectCourse();
      } else {
        this.getCourse();
      }
      this.scrollFun();
      // this.getLecturersList();
    },
    methods: {
      // getObj() {
      //
      //   let sessoinCourse = {};
      //   if (sessionStorage.getItem("currentCourse")) {
      //     sessoinCourse = JSON.parse(sessionStorage.getItem("currentCourse"));
      //     if (sessoinCourse.id && sessoinCourse.id === this.courseId) {
      //       this.currentCourse = sessoinCourse;
      //       this.getProgress();
      //       //添加浏览器title
      //       this.$store.commit('SET_BROWHEADERTITLE', {
      //         browserHeaderTitle: this.currentCourse.title
      //       });
      //     } else {
      //       if (this.proId) {
      //         this.getProjectCourse();
      //       } else {
      //         this.getCourse();
      //       }
      //     }
      //
      //   } else {
      //     if(this.proId) {
      //       this.getProjectCourse();
      //     }else {
      //       this.getCourse();
      //     }
      //   }
      // },
      getCourse() {
        this.$store.dispatch('getCourseForLearner', {id: this.courseId}).then((res) => {
          this.currentCourse = res;
          this.getProgress();
          //添加浏览器title
          this.$store.commit('SET_BROWHEADERTITLE', {
            browserHeaderTitle: this.currentCourse.title
          });
          sessionStorage.setItem("currentCourse", JSON.stringify(this.currentCourse));
        })
      },
      getProjectCourse() {
        this.$store.dispatch('getProjectCourseForLearner', {id: this.courseId, proId: this.proId}).then((res) => {
          if(res && res.course) {
            this.currentCourse = res.course;
          }
          this.getProgress();
          //添加浏览器title
          this.$store.commit('SET_BROWHEADERTITLE', {
            browserHeaderTitle: this.currentCourse.title
          });
          sessionStorage.setItem('currentCourse', JSON.stringify(this.currentCourse));
        })
      },
      getProgress() {
        if (this.currentCourse.statInfo && this.currentCourse.statInfo.mustLearnSessionCount
          && this.currentCourse.userCourse && this.currentCourse.userCourse.progress) {
          this.currentCourse.progress =
            (this.currentCourse.userCourse.progress / this.currentCourse.statInfo.mustLearnSessionCount) * 100;
        } else {
          this.currentCourse.progress = 0;
        }
        //取出最后学习小节信息
        this.getLastLearnSession();

      },
      //临时获取专家列表
      getLecturersList() {
        this.$store.dispatch('getLecturersList').then((res) => {
          this.expertList = res;
        })
      },
      getLastLearnSession() {
        if (this.currentCourse && this.currentCourse.sessionList && this.currentCourse.sessionList.length > 0) {
          if (this.currentCourse.userCourse && this.currentCourse.userCourse.lastLearnSessionId) {
            this.alreadyLearned = true;
            for (let session of this.currentCourse.sessionList) {
              if (this.currentCourse.userCourse.lastLearnSessionId === session.id) {
                this.lastLearnSession = session;
                break;
              }
            }
          }
          if (!(this.lastLearnSession && this.lastLearnSession.id)) {

            this.lastLearnSession = this.currentCourse.sessionList.sort(this.compare('sort'))[0];
            console.log(this.currentCourse.sessionList.sort(this.compare('sort')))
          }
        }
      },
      compare(property) {
        return function (a, b) {
          let value1 = a[property];
          let value2 = b[property];
          return value1 - value2;
        }

      },
      scrollFun() {
        let _this = this;

        window.addEventListener('scroll', () => {
          let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;

          if (top > $('.course-main-top').height() - 30) {
            _this.isShow = true;
          } else {
            _this.isShow = false
          }
        })
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //
      //   this.shareObj = this.currentCourse;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'course';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },

    }
  }
</script>

<style>

</style>
